/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnauthorizedRouteImport } from './routes/unauthorized'
import { Route as TranslationsRouteImport } from './routes/translations'
import { Route as StudioRouteImport } from './routes/studio'
import { Route as RedirectRouteImport } from './routes/redirect'
import { Route as PlayerRouteImport } from './routes/player'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LobbyRouteImport } from './routes/lobby'
import { Route as IndexRouteImport } from './routes/index'
import { Route as StudioIndexRouteImport } from './routes/studio/index'
import { Route as LobbyIndexRouteImport } from './routes/lobby/index'
import { Route as StudioTemplatesRouteImport } from './routes/studio/templates'
import { Route as StudioPblRouteImport } from './routes/studio/pbl'
import { Route as StudioCoursesRouteImport } from './routes/studio/courses'
import { Route as StudioBinRouteImport } from './routes/studio/bin'
import { Route as PlayerLearningObjectDraftIdRouteImport } from './routes/player/$learningObjectDraftId'
import { Route as LobbySignupRouteImport } from './routes/lobby/signup'
import { Route as LobbyPlenaryEndedRouteImport } from './routes/lobby/plenary-ended'
import { Route as StudioPlenaryNewRouteImport } from './routes/studio/plenary/new'
import { Route as StudioPblNewRouteImport } from './routes/studio/pbl/new'
import { Route as StudioLearningActivityNewRouteImport } from './routes/studio/learning-activity/new'
import { Route as StudioCoursesNewRouteImport } from './routes/studio/courses/new'
import { Route as PlayerPlenaryLearningObjectDraftIdRouteImport } from './routes/player/plenary/$learningObjectDraftId'
import { Route as PlayerPblPblDraftIdRouteImport } from './routes/player/pbl/$pblDraftId'
import { Route as PlayerLearningActivityLearningActivityDraftIdRouteImport } from './routes/player/learning-activity/$learningActivityDraftId'
import { Route as PlayerCoursesCourseDraftIdentifierRouteImport } from './routes/player/courses/$courseDraftIdentifier'
import { Route as PlayerAssignmentAssignmentIdRouteImport } from './routes/player/assignment/$assignmentId'
import { Route as PlayerCoursesCourseDraftIdentifierIndexRouteImport } from './routes/player/courses/$courseDraftIdentifier.index'
import { Route as StudioPlenaryPreviewPlenaryDraftIdRouteImport } from './routes/studio/plenary/preview.$plenaryDraftId'
import { Route as StudioPblPreviewPblDraftIdRouteImport } from './routes/studio/pbl/preview.$pblDraftId'
import { Route as StudioPblEditPblDraftIdRouteImport } from './routes/studio/pbl/edit.$pblDraftId'
import { Route as StudioLearningActivityPreviewLearningActivityDraftIdRouteImport } from './routes/studio/learning-activity/preview.$learningActivityDraftId'
import { Route as StudioCoursesPreviewCourseDraftIdRouteImport } from './routes/studio/courses/preview.$courseDraftId'
import { Route as StudioCoursesEditCourseDraftIdRouteImport } from './routes/studio/courses/edit.$courseDraftId'
import { Route as StudioPlenaryEditPlenaryDraftIdIndexRouteImport } from './routes/studio/plenary/edit.$plenaryDraftId/index'
import { Route as StudioLearningActivityEditLearningActivityDraftIdIndexRouteImport } from './routes/studio/learning-activity/edit.$learningActivityDraftId/index'
import { Route as StudioCoursesPreviewCourseDraftIdIndexRouteImport } from './routes/studio/courses/preview.$courseDraftId.index'
import { Route as StudioCoursesEditCourseDraftIdIndexRouteImport } from './routes/studio/courses/edit.$courseDraftId.index'
import { Route as PlayerCoursesCourseDraftIdentifierCategoryIdIndexRouteImport } from './routes/player/courses/$courseDraftIdentifier.$categoryId.index'
import { Route as StudioCoursesEditCourseDraftIdCategoryIdRouteImport } from './routes/studio/courses/edit.$courseDraftId.$categoryId'
import { Route as PlayerCoursesCourseDraftIdentifierCategoryIdActivityIdRouteImport } from './routes/player/courses/$courseDraftIdentifier.$categoryId.$activityId'
import { Route as StudioPlenaryEditPlenaryDraftIdVersionsIndexRouteImport } from './routes/studio/plenary/edit.$plenaryDraftId/versions/index'
import { Route as StudioLearningActivityEditLearningActivityDraftIdVersionsIndexRouteImport } from './routes/studio/learning-activity/edit.$learningActivityDraftId/versions/index'
import { Route as StudioCoursesPreviewCourseDraftIdCategoryIdIndexRouteImport } from './routes/studio/courses/preview.$courseDraftId.$categoryId.index'
import { Route as StudioPlenaryEditPlenaryDraftIdVersionsPlenarySnapshotIdRouteImport } from './routes/studio/plenary/edit.$plenaryDraftId/versions/$plenarySnapshotId'
import { Route as StudioLearningActivityEditLearningActivityDraftIdVersionsLearningActivitySnapshotIdRouteImport } from './routes/studio/learning-activity/edit.$learningActivityDraftId/versions/$learningActivitySnapshotId'
import { Route as StudioCoursesPreviewCourseDraftIdCategoryIdActivityIdRouteImport } from './routes/studio/courses/preview.$courseDraftId.$categoryId.$activityId'

const UnauthorizedRoute = UnauthorizedRouteImport.update({
  id: '/unauthorized',
  path: '/unauthorized',
  getParentRoute: () => rootRouteImport,
} as any)
const TranslationsRoute = TranslationsRouteImport.update({
  id: '/translations',
  path: '/translations',
  getParentRoute: () => rootRouteImport,
} as any)
const StudioRoute = StudioRouteImport.update({
  id: '/studio',
  path: '/studio',
  getParentRoute: () => rootRouteImport,
} as any)
const RedirectRoute = RedirectRouteImport.update({
  id: '/redirect',
  path: '/redirect',
  getParentRoute: () => rootRouteImport,
} as any)
const PlayerRoute = PlayerRouteImport.update({
  id: '/player',
  path: '/player',
  getParentRoute: () => rootRouteImport,
} as any)
const LogoutRoute = LogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const LobbyRoute = LobbyRouteImport.update({
  id: '/lobby',
  path: '/lobby',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const StudioIndexRoute = StudioIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StudioRoute,
} as any)
const LobbyIndexRoute = LobbyIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LobbyRoute,
} as any)
const StudioTemplatesRoute = StudioTemplatesRouteImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => StudioRoute,
} as any)
const StudioPblRoute = StudioPblRouteImport.update({
  id: '/pbl',
  path: '/pbl',
  getParentRoute: () => StudioRoute,
} as any)
const StudioCoursesRoute = StudioCoursesRouteImport.update({
  id: '/courses',
  path: '/courses',
  getParentRoute: () => StudioRoute,
} as any)
const StudioBinRoute = StudioBinRouteImport.update({
  id: '/bin',
  path: '/bin',
  getParentRoute: () => StudioRoute,
} as any)
const PlayerLearningObjectDraftIdRoute =
  PlayerLearningObjectDraftIdRouteImport.update({
    id: '/$learningObjectDraftId',
    path: '/$learningObjectDraftId',
    getParentRoute: () => PlayerRoute,
  } as any)
const LobbySignupRoute = LobbySignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => LobbyRoute,
} as any)
const LobbyPlenaryEndedRoute = LobbyPlenaryEndedRouteImport.update({
  id: '/plenary-ended',
  path: '/plenary-ended',
  getParentRoute: () => LobbyRoute,
} as any)
const StudioPlenaryNewRoute = StudioPlenaryNewRouteImport.update({
  id: '/plenary/new',
  path: '/plenary/new',
  getParentRoute: () => StudioRoute,
} as any)
const StudioPblNewRoute = StudioPblNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => StudioPblRoute,
} as any)
const StudioLearningActivityNewRoute =
  StudioLearningActivityNewRouteImport.update({
    id: '/learning-activity/new',
    path: '/learning-activity/new',
    getParentRoute: () => StudioRoute,
  } as any)
const StudioCoursesNewRoute = StudioCoursesNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => StudioCoursesRoute,
} as any)
const PlayerPlenaryLearningObjectDraftIdRoute =
  PlayerPlenaryLearningObjectDraftIdRouteImport.update({
    id: '/plenary/$learningObjectDraftId',
    path: '/plenary/$learningObjectDraftId',
    getParentRoute: () => PlayerRoute,
  } as any)
const PlayerPblPblDraftIdRoute = PlayerPblPblDraftIdRouteImport.update({
  id: '/pbl/$pblDraftId',
  path: '/pbl/$pblDraftId',
  getParentRoute: () => PlayerRoute,
} as any)
const PlayerLearningActivityLearningActivityDraftIdRoute =
  PlayerLearningActivityLearningActivityDraftIdRouteImport.update({
    id: '/learning-activity/$learningActivityDraftId',
    path: '/learning-activity/$learningActivityDraftId',
    getParentRoute: () => PlayerRoute,
  } as any)
const PlayerCoursesCourseDraftIdentifierRoute =
  PlayerCoursesCourseDraftIdentifierRouteImport.update({
    id: '/courses/$courseDraftIdentifier',
    path: '/courses/$courseDraftIdentifier',
    getParentRoute: () => PlayerRoute,
  } as any)
const PlayerAssignmentAssignmentIdRoute =
  PlayerAssignmentAssignmentIdRouteImport.update({
    id: '/assignment/$assignmentId',
    path: '/assignment/$assignmentId',
    getParentRoute: () => PlayerRoute,
  } as any)
const PlayerCoursesCourseDraftIdentifierIndexRoute =
  PlayerCoursesCourseDraftIdentifierIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PlayerCoursesCourseDraftIdentifierRoute,
  } as any)
const StudioPlenaryPreviewPlenaryDraftIdRoute =
  StudioPlenaryPreviewPlenaryDraftIdRouteImport.update({
    id: '/plenary/preview/$plenaryDraftId',
    path: '/plenary/preview/$plenaryDraftId',
    getParentRoute: () => StudioRoute,
  } as any)
const StudioPblPreviewPblDraftIdRoute =
  StudioPblPreviewPblDraftIdRouteImport.update({
    id: '/preview/$pblDraftId',
    path: '/preview/$pblDraftId',
    getParentRoute: () => StudioPblRoute,
  } as any)
const StudioPblEditPblDraftIdRoute = StudioPblEditPblDraftIdRouteImport.update({
  id: '/edit/$pblDraftId',
  path: '/edit/$pblDraftId',
  getParentRoute: () => StudioPblRoute,
} as any)
const StudioLearningActivityPreviewLearningActivityDraftIdRoute =
  StudioLearningActivityPreviewLearningActivityDraftIdRouteImport.update({
    id: '/learning-activity/preview/$learningActivityDraftId',
    path: '/learning-activity/preview/$learningActivityDraftId',
    getParentRoute: () => StudioRoute,
  } as any)
const StudioCoursesPreviewCourseDraftIdRoute =
  StudioCoursesPreviewCourseDraftIdRouteImport.update({
    id: '/preview/$courseDraftId',
    path: '/preview/$courseDraftId',
    getParentRoute: () => StudioCoursesRoute,
  } as any)
const StudioCoursesEditCourseDraftIdRoute =
  StudioCoursesEditCourseDraftIdRouteImport.update({
    id: '/edit/$courseDraftId',
    path: '/edit/$courseDraftId',
    getParentRoute: () => StudioCoursesRoute,
  } as any)
const StudioPlenaryEditPlenaryDraftIdIndexRoute =
  StudioPlenaryEditPlenaryDraftIdIndexRouteImport.update({
    id: '/plenary/edit/$plenaryDraftId/',
    path: '/plenary/edit/$plenaryDraftId/',
    getParentRoute: () => StudioRoute,
  } as any)
const StudioLearningActivityEditLearningActivityDraftIdIndexRoute =
  StudioLearningActivityEditLearningActivityDraftIdIndexRouteImport.update({
    id: '/learning-activity/edit/$learningActivityDraftId/',
    path: '/learning-activity/edit/$learningActivityDraftId/',
    getParentRoute: () => StudioRoute,
  } as any)
const StudioCoursesPreviewCourseDraftIdIndexRoute =
  StudioCoursesPreviewCourseDraftIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StudioCoursesPreviewCourseDraftIdRoute,
  } as any)
const StudioCoursesEditCourseDraftIdIndexRoute =
  StudioCoursesEditCourseDraftIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StudioCoursesEditCourseDraftIdRoute,
  } as any)
const PlayerCoursesCourseDraftIdentifierCategoryIdIndexRoute =
  PlayerCoursesCourseDraftIdentifierCategoryIdIndexRouteImport.update({
    id: '/$categoryId/',
    path: '/$categoryId/',
    getParentRoute: () => PlayerCoursesCourseDraftIdentifierRoute,
  } as any)
const StudioCoursesEditCourseDraftIdCategoryIdRoute =
  StudioCoursesEditCourseDraftIdCategoryIdRouteImport.update({
    id: '/$categoryId',
    path: '/$categoryId',
    getParentRoute: () => StudioCoursesEditCourseDraftIdRoute,
  } as any)
const PlayerCoursesCourseDraftIdentifierCategoryIdActivityIdRoute =
  PlayerCoursesCourseDraftIdentifierCategoryIdActivityIdRouteImport.update({
    id: '/$categoryId/$activityId',
    path: '/$categoryId/$activityId',
    getParentRoute: () => PlayerCoursesCourseDraftIdentifierRoute,
  } as any)
const StudioPlenaryEditPlenaryDraftIdVersionsIndexRoute =
  StudioPlenaryEditPlenaryDraftIdVersionsIndexRouteImport.update({
    id: '/plenary/edit/$plenaryDraftId/versions/',
    path: '/plenary/edit/$plenaryDraftId/versions/',
    getParentRoute: () => StudioRoute,
  } as any)
const StudioLearningActivityEditLearningActivityDraftIdVersionsIndexRoute =
  StudioLearningActivityEditLearningActivityDraftIdVersionsIndexRouteImport.update(
    {
      id: '/learning-activity/edit/$learningActivityDraftId/versions/',
      path: '/learning-activity/edit/$learningActivityDraftId/versions/',
      getParentRoute: () => StudioRoute,
    } as any,
  )
const StudioCoursesPreviewCourseDraftIdCategoryIdIndexRoute =
  StudioCoursesPreviewCourseDraftIdCategoryIdIndexRouteImport.update({
    id: '/$categoryId/',
    path: '/$categoryId/',
    getParentRoute: () => StudioCoursesPreviewCourseDraftIdRoute,
  } as any)
const StudioPlenaryEditPlenaryDraftIdVersionsPlenarySnapshotIdRoute =
  StudioPlenaryEditPlenaryDraftIdVersionsPlenarySnapshotIdRouteImport.update({
    id: '/plenary/edit/$plenaryDraftId/versions/$plenarySnapshotId',
    path: '/plenary/edit/$plenaryDraftId/versions/$plenarySnapshotId',
    getParentRoute: () => StudioRoute,
  } as any)
const StudioLearningActivityEditLearningActivityDraftIdVersionsLearningActivitySnapshotIdRoute =
  StudioLearningActivityEditLearningActivityDraftIdVersionsLearningActivitySnapshotIdRouteImport.update(
    {
      id: '/learning-activity/edit/$learningActivityDraftId/versions/$learningActivitySnapshotId',
      path: '/learning-activity/edit/$learningActivityDraftId/versions/$learningActivitySnapshotId',
      getParentRoute: () => StudioRoute,
    } as any,
  )
const StudioCoursesPreviewCourseDraftIdCategoryIdActivityIdRoute =
  StudioCoursesPreviewCourseDraftIdCategoryIdActivityIdRouteImport.update({
    id: '/$categoryId/$activityId',
    path: '/$categoryId/$activityId',
    getParentRoute: () => StudioCoursesPreviewCourseDraftIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/lobby': typeof LobbyRouteWithChildren
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/player': typeof PlayerRouteWithChildren
  '/redirect': typeof RedirectRoute
  '/studio': typeof StudioRouteWithChildren
  '/translations': typeof TranslationsRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/lobby/plenary-ended': typeof LobbyPlenaryEndedRoute
  '/lobby/signup': typeof LobbySignupRoute
  '/player/$learningObjectDraftId': typeof PlayerLearningObjectDraftIdRoute
  '/studio/bin': typeof StudioBinRoute
  '/studio/courses': typeof StudioCoursesRouteWithChildren
  '/studio/pbl': typeof StudioPblRouteWithChildren
  '/studio/templates': typeof StudioTemplatesRoute
  '/lobby/': typeof LobbyIndexRoute
  '/studio/': typeof StudioIndexRoute
  '/player/assignment/$assignmentId': typeof PlayerAssignmentAssignmentIdRoute
  '/player/courses/$courseDraftIdentifier': typeof PlayerCoursesCourseDraftIdentifierRouteWithChildren
  '/player/learning-activity/$learningActivityDraftId': typeof PlayerLearningActivityLearningActivityDraftIdRoute
  '/player/pbl/$pblDraftId': typeof PlayerPblPblDraftIdRoute
  '/player/plenary/$learningObjectDraftId': typeof PlayerPlenaryLearningObjectDraftIdRoute
  '/studio/courses/new': typeof StudioCoursesNewRoute
  '/studio/learning-activity/new': typeof StudioLearningActivityNewRoute
  '/studio/pbl/new': typeof StudioPblNewRoute
  '/studio/plenary/new': typeof StudioPlenaryNewRoute
  '/studio/courses/edit/$courseDraftId': typeof StudioCoursesEditCourseDraftIdRouteWithChildren
  '/studio/courses/preview/$courseDraftId': typeof StudioCoursesPreviewCourseDraftIdRouteWithChildren
  '/studio/learning-activity/preview/$learningActivityDraftId': typeof StudioLearningActivityPreviewLearningActivityDraftIdRoute
  '/studio/pbl/edit/$pblDraftId': typeof StudioPblEditPblDraftIdRoute
  '/studio/pbl/preview/$pblDraftId': typeof StudioPblPreviewPblDraftIdRoute
  '/studio/plenary/preview/$plenaryDraftId': typeof StudioPlenaryPreviewPlenaryDraftIdRoute
  '/player/courses/$courseDraftIdentifier/': typeof PlayerCoursesCourseDraftIdentifierIndexRoute
  '/player/courses/$courseDraftIdentifier/$categoryId/$activityId': typeof PlayerCoursesCourseDraftIdentifierCategoryIdActivityIdRoute
  '/studio/courses/edit/$courseDraftId/$categoryId': typeof StudioCoursesEditCourseDraftIdCategoryIdRoute
  '/player/courses/$courseDraftIdentifier/$categoryId': typeof PlayerCoursesCourseDraftIdentifierCategoryIdIndexRoute
  '/studio/courses/edit/$courseDraftId/': typeof StudioCoursesEditCourseDraftIdIndexRoute
  '/studio/courses/preview/$courseDraftId/': typeof StudioCoursesPreviewCourseDraftIdIndexRoute
  '/studio/learning-activity/edit/$learningActivityDraftId': typeof StudioLearningActivityEditLearningActivityDraftIdIndexRoute
  '/studio/plenary/edit/$plenaryDraftId': typeof StudioPlenaryEditPlenaryDraftIdIndexRoute
  '/studio/courses/preview/$courseDraftId/$categoryId/$activityId': typeof StudioCoursesPreviewCourseDraftIdCategoryIdActivityIdRoute
  '/studio/learning-activity/edit/$learningActivityDraftId/versions/$learningActivitySnapshotId': typeof StudioLearningActivityEditLearningActivityDraftIdVersionsLearningActivitySnapshotIdRoute
  '/studio/plenary/edit/$plenaryDraftId/versions/$plenarySnapshotId': typeof StudioPlenaryEditPlenaryDraftIdVersionsPlenarySnapshotIdRoute
  '/studio/courses/preview/$courseDraftId/$categoryId': typeof StudioCoursesPreviewCourseDraftIdCategoryIdIndexRoute
  '/studio/learning-activity/edit/$learningActivityDraftId/versions': typeof StudioLearningActivityEditLearningActivityDraftIdVersionsIndexRoute
  '/studio/plenary/edit/$plenaryDraftId/versions': typeof StudioPlenaryEditPlenaryDraftIdVersionsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/player': typeof PlayerRouteWithChildren
  '/redirect': typeof RedirectRoute
  '/translations': typeof TranslationsRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/lobby/plenary-ended': typeof LobbyPlenaryEndedRoute
  '/lobby/signup': typeof LobbySignupRoute
  '/player/$learningObjectDraftId': typeof PlayerLearningObjectDraftIdRoute
  '/studio/bin': typeof StudioBinRoute
  '/studio/courses': typeof StudioCoursesRouteWithChildren
  '/studio/pbl': typeof StudioPblRouteWithChildren
  '/studio/templates': typeof StudioTemplatesRoute
  '/lobby': typeof LobbyIndexRoute
  '/studio': typeof StudioIndexRoute
  '/player/assignment/$assignmentId': typeof PlayerAssignmentAssignmentIdRoute
  '/player/learning-activity/$learningActivityDraftId': typeof PlayerLearningActivityLearningActivityDraftIdRoute
  '/player/pbl/$pblDraftId': typeof PlayerPblPblDraftIdRoute
  '/player/plenary/$learningObjectDraftId': typeof PlayerPlenaryLearningObjectDraftIdRoute
  '/studio/courses/new': typeof StudioCoursesNewRoute
  '/studio/learning-activity/new': typeof StudioLearningActivityNewRoute
  '/studio/pbl/new': typeof StudioPblNewRoute
  '/studio/plenary/new': typeof StudioPlenaryNewRoute
  '/studio/learning-activity/preview/$learningActivityDraftId': typeof StudioLearningActivityPreviewLearningActivityDraftIdRoute
  '/studio/pbl/edit/$pblDraftId': typeof StudioPblEditPblDraftIdRoute
  '/studio/pbl/preview/$pblDraftId': typeof StudioPblPreviewPblDraftIdRoute
  '/studio/plenary/preview/$plenaryDraftId': typeof StudioPlenaryPreviewPlenaryDraftIdRoute
  '/player/courses/$courseDraftIdentifier': typeof PlayerCoursesCourseDraftIdentifierIndexRoute
  '/player/courses/$courseDraftIdentifier/$categoryId/$activityId': typeof PlayerCoursesCourseDraftIdentifierCategoryIdActivityIdRoute
  '/studio/courses/edit/$courseDraftId/$categoryId': typeof StudioCoursesEditCourseDraftIdCategoryIdRoute
  '/player/courses/$courseDraftIdentifier/$categoryId': typeof PlayerCoursesCourseDraftIdentifierCategoryIdIndexRoute
  '/studio/courses/edit/$courseDraftId': typeof StudioCoursesEditCourseDraftIdIndexRoute
  '/studio/courses/preview/$courseDraftId': typeof StudioCoursesPreviewCourseDraftIdIndexRoute
  '/studio/learning-activity/edit/$learningActivityDraftId': typeof StudioLearningActivityEditLearningActivityDraftIdIndexRoute
  '/studio/plenary/edit/$plenaryDraftId': typeof StudioPlenaryEditPlenaryDraftIdIndexRoute
  '/studio/courses/preview/$courseDraftId/$categoryId/$activityId': typeof StudioCoursesPreviewCourseDraftIdCategoryIdActivityIdRoute
  '/studio/learning-activity/edit/$learningActivityDraftId/versions/$learningActivitySnapshotId': typeof StudioLearningActivityEditLearningActivityDraftIdVersionsLearningActivitySnapshotIdRoute
  '/studio/plenary/edit/$plenaryDraftId/versions/$plenarySnapshotId': typeof StudioPlenaryEditPlenaryDraftIdVersionsPlenarySnapshotIdRoute
  '/studio/courses/preview/$courseDraftId/$categoryId': typeof StudioCoursesPreviewCourseDraftIdCategoryIdIndexRoute
  '/studio/learning-activity/edit/$learningActivityDraftId/versions': typeof StudioLearningActivityEditLearningActivityDraftIdVersionsIndexRoute
  '/studio/plenary/edit/$plenaryDraftId/versions': typeof StudioPlenaryEditPlenaryDraftIdVersionsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/lobby': typeof LobbyRouteWithChildren
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/player': typeof PlayerRouteWithChildren
  '/redirect': typeof RedirectRoute
  '/studio': typeof StudioRouteWithChildren
  '/translations': typeof TranslationsRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/lobby/plenary-ended': typeof LobbyPlenaryEndedRoute
  '/lobby/signup': typeof LobbySignupRoute
  '/player/$learningObjectDraftId': typeof PlayerLearningObjectDraftIdRoute
  '/studio/bin': typeof StudioBinRoute
  '/studio/courses': typeof StudioCoursesRouteWithChildren
  '/studio/pbl': typeof StudioPblRouteWithChildren
  '/studio/templates': typeof StudioTemplatesRoute
  '/lobby/': typeof LobbyIndexRoute
  '/studio/': typeof StudioIndexRoute
  '/player/assignment/$assignmentId': typeof PlayerAssignmentAssignmentIdRoute
  '/player/courses/$courseDraftIdentifier': typeof PlayerCoursesCourseDraftIdentifierRouteWithChildren
  '/player/learning-activity/$learningActivityDraftId': typeof PlayerLearningActivityLearningActivityDraftIdRoute
  '/player/pbl/$pblDraftId': typeof PlayerPblPblDraftIdRoute
  '/player/plenary/$learningObjectDraftId': typeof PlayerPlenaryLearningObjectDraftIdRoute
  '/studio/courses/new': typeof StudioCoursesNewRoute
  '/studio/learning-activity/new': typeof StudioLearningActivityNewRoute
  '/studio/pbl/new': typeof StudioPblNewRoute
  '/studio/plenary/new': typeof StudioPlenaryNewRoute
  '/studio/courses/edit/$courseDraftId': typeof StudioCoursesEditCourseDraftIdRouteWithChildren
  '/studio/courses/preview/$courseDraftId': typeof StudioCoursesPreviewCourseDraftIdRouteWithChildren
  '/studio/learning-activity/preview/$learningActivityDraftId': typeof StudioLearningActivityPreviewLearningActivityDraftIdRoute
  '/studio/pbl/edit/$pblDraftId': typeof StudioPblEditPblDraftIdRoute
  '/studio/pbl/preview/$pblDraftId': typeof StudioPblPreviewPblDraftIdRoute
  '/studio/plenary/preview/$plenaryDraftId': typeof StudioPlenaryPreviewPlenaryDraftIdRoute
  '/player/courses/$courseDraftIdentifier/': typeof PlayerCoursesCourseDraftIdentifierIndexRoute
  '/player/courses/$courseDraftIdentifier/$categoryId/$activityId': typeof PlayerCoursesCourseDraftIdentifierCategoryIdActivityIdRoute
  '/studio/courses/edit/$courseDraftId/$categoryId': typeof StudioCoursesEditCourseDraftIdCategoryIdRoute
  '/player/courses/$courseDraftIdentifier/$categoryId/': typeof PlayerCoursesCourseDraftIdentifierCategoryIdIndexRoute
  '/studio/courses/edit/$courseDraftId/': typeof StudioCoursesEditCourseDraftIdIndexRoute
  '/studio/courses/preview/$courseDraftId/': typeof StudioCoursesPreviewCourseDraftIdIndexRoute
  '/studio/learning-activity/edit/$learningActivityDraftId/': typeof StudioLearningActivityEditLearningActivityDraftIdIndexRoute
  '/studio/plenary/edit/$plenaryDraftId/': typeof StudioPlenaryEditPlenaryDraftIdIndexRoute
  '/studio/courses/preview/$courseDraftId/$categoryId/$activityId': typeof StudioCoursesPreviewCourseDraftIdCategoryIdActivityIdRoute
  '/studio/learning-activity/edit/$learningActivityDraftId/versions/$learningActivitySnapshotId': typeof StudioLearningActivityEditLearningActivityDraftIdVersionsLearningActivitySnapshotIdRoute
  '/studio/plenary/edit/$plenaryDraftId/versions/$plenarySnapshotId': typeof StudioPlenaryEditPlenaryDraftIdVersionsPlenarySnapshotIdRoute
  '/studio/courses/preview/$courseDraftId/$categoryId/': typeof StudioCoursesPreviewCourseDraftIdCategoryIdIndexRoute
  '/studio/learning-activity/edit/$learningActivityDraftId/versions/': typeof StudioLearningActivityEditLearningActivityDraftIdVersionsIndexRoute
  '/studio/plenary/edit/$plenaryDraftId/versions/': typeof StudioPlenaryEditPlenaryDraftIdVersionsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/lobby'
    | '/login'
    | '/logout'
    | '/player'
    | '/redirect'
    | '/studio'
    | '/translations'
    | '/unauthorized'
    | '/lobby/plenary-ended'
    | '/lobby/signup'
    | '/player/$learningObjectDraftId'
    | '/studio/bin'
    | '/studio/courses'
    | '/studio/pbl'
    | '/studio/templates'
    | '/lobby/'
    | '/studio/'
    | '/player/assignment/$assignmentId'
    | '/player/courses/$courseDraftIdentifier'
    | '/player/learning-activity/$learningActivityDraftId'
    | '/player/pbl/$pblDraftId'
    | '/player/plenary/$learningObjectDraftId'
    | '/studio/courses/new'
    | '/studio/learning-activity/new'
    | '/studio/pbl/new'
    | '/studio/plenary/new'
    | '/studio/courses/edit/$courseDraftId'
    | '/studio/courses/preview/$courseDraftId'
    | '/studio/learning-activity/preview/$learningActivityDraftId'
    | '/studio/pbl/edit/$pblDraftId'
    | '/studio/pbl/preview/$pblDraftId'
    | '/studio/plenary/preview/$plenaryDraftId'
    | '/player/courses/$courseDraftIdentifier/'
    | '/player/courses/$courseDraftIdentifier/$categoryId/$activityId'
    | '/studio/courses/edit/$courseDraftId/$categoryId'
    | '/player/courses/$courseDraftIdentifier/$categoryId'
    | '/studio/courses/edit/$courseDraftId/'
    | '/studio/courses/preview/$courseDraftId/'
    | '/studio/learning-activity/edit/$learningActivityDraftId'
    | '/studio/plenary/edit/$plenaryDraftId'
    | '/studio/courses/preview/$courseDraftId/$categoryId/$activityId'
    | '/studio/learning-activity/edit/$learningActivityDraftId/versions/$learningActivitySnapshotId'
    | '/studio/plenary/edit/$plenaryDraftId/versions/$plenarySnapshotId'
    | '/studio/courses/preview/$courseDraftId/$categoryId'
    | '/studio/learning-activity/edit/$learningActivityDraftId/versions'
    | '/studio/plenary/edit/$plenaryDraftId/versions'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/logout'
    | '/player'
    | '/redirect'
    | '/translations'
    | '/unauthorized'
    | '/lobby/plenary-ended'
    | '/lobby/signup'
    | '/player/$learningObjectDraftId'
    | '/studio/bin'
    | '/studio/courses'
    | '/studio/pbl'
    | '/studio/templates'
    | '/lobby'
    | '/studio'
    | '/player/assignment/$assignmentId'
    | '/player/learning-activity/$learningActivityDraftId'
    | '/player/pbl/$pblDraftId'
    | '/player/plenary/$learningObjectDraftId'
    | '/studio/courses/new'
    | '/studio/learning-activity/new'
    | '/studio/pbl/new'
    | '/studio/plenary/new'
    | '/studio/learning-activity/preview/$learningActivityDraftId'
    | '/studio/pbl/edit/$pblDraftId'
    | '/studio/pbl/preview/$pblDraftId'
    | '/studio/plenary/preview/$plenaryDraftId'
    | '/player/courses/$courseDraftIdentifier'
    | '/player/courses/$courseDraftIdentifier/$categoryId/$activityId'
    | '/studio/courses/edit/$courseDraftId/$categoryId'
    | '/player/courses/$courseDraftIdentifier/$categoryId'
    | '/studio/courses/edit/$courseDraftId'
    | '/studio/courses/preview/$courseDraftId'
    | '/studio/learning-activity/edit/$learningActivityDraftId'
    | '/studio/plenary/edit/$plenaryDraftId'
    | '/studio/courses/preview/$courseDraftId/$categoryId/$activityId'
    | '/studio/learning-activity/edit/$learningActivityDraftId/versions/$learningActivitySnapshotId'
    | '/studio/plenary/edit/$plenaryDraftId/versions/$plenarySnapshotId'
    | '/studio/courses/preview/$courseDraftId/$categoryId'
    | '/studio/learning-activity/edit/$learningActivityDraftId/versions'
    | '/studio/plenary/edit/$plenaryDraftId/versions'
  id:
    | '__root__'
    | '/'
    | '/lobby'
    | '/login'
    | '/logout'
    | '/player'
    | '/redirect'
    | '/studio'
    | '/translations'
    | '/unauthorized'
    | '/lobby/plenary-ended'
    | '/lobby/signup'
    | '/player/$learningObjectDraftId'
    | '/studio/bin'
    | '/studio/courses'
    | '/studio/pbl'
    | '/studio/templates'
    | '/lobby/'
    | '/studio/'
    | '/player/assignment/$assignmentId'
    | '/player/courses/$courseDraftIdentifier'
    | '/player/learning-activity/$learningActivityDraftId'
    | '/player/pbl/$pblDraftId'
    | '/player/plenary/$learningObjectDraftId'
    | '/studio/courses/new'
    | '/studio/learning-activity/new'
    | '/studio/pbl/new'
    | '/studio/plenary/new'
    | '/studio/courses/edit/$courseDraftId'
    | '/studio/courses/preview/$courseDraftId'
    | '/studio/learning-activity/preview/$learningActivityDraftId'
    | '/studio/pbl/edit/$pblDraftId'
    | '/studio/pbl/preview/$pblDraftId'
    | '/studio/plenary/preview/$plenaryDraftId'
    | '/player/courses/$courseDraftIdentifier/'
    | '/player/courses/$courseDraftIdentifier/$categoryId/$activityId'
    | '/studio/courses/edit/$courseDraftId/$categoryId'
    | '/player/courses/$courseDraftIdentifier/$categoryId/'
    | '/studio/courses/edit/$courseDraftId/'
    | '/studio/courses/preview/$courseDraftId/'
    | '/studio/learning-activity/edit/$learningActivityDraftId/'
    | '/studio/plenary/edit/$plenaryDraftId/'
    | '/studio/courses/preview/$courseDraftId/$categoryId/$activityId'
    | '/studio/learning-activity/edit/$learningActivityDraftId/versions/$learningActivitySnapshotId'
    | '/studio/plenary/edit/$plenaryDraftId/versions/$plenarySnapshotId'
    | '/studio/courses/preview/$courseDraftId/$categoryId/'
    | '/studio/learning-activity/edit/$learningActivityDraftId/versions/'
    | '/studio/plenary/edit/$plenaryDraftId/versions/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LobbyRoute: typeof LobbyRouteWithChildren
  LoginRoute: typeof LoginRoute
  LogoutRoute: typeof LogoutRoute
  PlayerRoute: typeof PlayerRouteWithChildren
  RedirectRoute: typeof RedirectRoute
  StudioRoute: typeof StudioRouteWithChildren
  TranslationsRoute: typeof TranslationsRoute
  UnauthorizedRoute: typeof UnauthorizedRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/unauthorized': {
      id: '/unauthorized'
      path: '/unauthorized'
      fullPath: '/unauthorized'
      preLoaderRoute: typeof UnauthorizedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/translations': {
      id: '/translations'
      path: '/translations'
      fullPath: '/translations'
      preLoaderRoute: typeof TranslationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/studio': {
      id: '/studio'
      path: '/studio'
      fullPath: '/studio'
      preLoaderRoute: typeof StudioRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/redirect': {
      id: '/redirect'
      path: '/redirect'
      fullPath: '/redirect'
      preLoaderRoute: typeof RedirectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/player': {
      id: '/player'
      path: '/player'
      fullPath: '/player'
      preLoaderRoute: typeof PlayerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lobby': {
      id: '/lobby'
      path: '/lobby'
      fullPath: '/lobby'
      preLoaderRoute: typeof LobbyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/studio/': {
      id: '/studio/'
      path: '/'
      fullPath: '/studio/'
      preLoaderRoute: typeof StudioIndexRouteImport
      parentRoute: typeof StudioRoute
    }
    '/lobby/': {
      id: '/lobby/'
      path: '/'
      fullPath: '/lobby/'
      preLoaderRoute: typeof LobbyIndexRouteImport
      parentRoute: typeof LobbyRoute
    }
    '/studio/templates': {
      id: '/studio/templates'
      path: '/templates'
      fullPath: '/studio/templates'
      preLoaderRoute: typeof StudioTemplatesRouteImport
      parentRoute: typeof StudioRoute
    }
    '/studio/pbl': {
      id: '/studio/pbl'
      path: '/pbl'
      fullPath: '/studio/pbl'
      preLoaderRoute: typeof StudioPblRouteImport
      parentRoute: typeof StudioRoute
    }
    '/studio/courses': {
      id: '/studio/courses'
      path: '/courses'
      fullPath: '/studio/courses'
      preLoaderRoute: typeof StudioCoursesRouteImport
      parentRoute: typeof StudioRoute
    }
    '/studio/bin': {
      id: '/studio/bin'
      path: '/bin'
      fullPath: '/studio/bin'
      preLoaderRoute: typeof StudioBinRouteImport
      parentRoute: typeof StudioRoute
    }
    '/player/$learningObjectDraftId': {
      id: '/player/$learningObjectDraftId'
      path: '/$learningObjectDraftId'
      fullPath: '/player/$learningObjectDraftId'
      preLoaderRoute: typeof PlayerLearningObjectDraftIdRouteImport
      parentRoute: typeof PlayerRoute
    }
    '/lobby/signup': {
      id: '/lobby/signup'
      path: '/signup'
      fullPath: '/lobby/signup'
      preLoaderRoute: typeof LobbySignupRouteImport
      parentRoute: typeof LobbyRoute
    }
    '/lobby/plenary-ended': {
      id: '/lobby/plenary-ended'
      path: '/plenary-ended'
      fullPath: '/lobby/plenary-ended'
      preLoaderRoute: typeof LobbyPlenaryEndedRouteImport
      parentRoute: typeof LobbyRoute
    }
    '/studio/plenary/new': {
      id: '/studio/plenary/new'
      path: '/plenary/new'
      fullPath: '/studio/plenary/new'
      preLoaderRoute: typeof StudioPlenaryNewRouteImport
      parentRoute: typeof StudioRoute
    }
    '/studio/pbl/new': {
      id: '/studio/pbl/new'
      path: '/new'
      fullPath: '/studio/pbl/new'
      preLoaderRoute: typeof StudioPblNewRouteImport
      parentRoute: typeof StudioPblRoute
    }
    '/studio/learning-activity/new': {
      id: '/studio/learning-activity/new'
      path: '/learning-activity/new'
      fullPath: '/studio/learning-activity/new'
      preLoaderRoute: typeof StudioLearningActivityNewRouteImport
      parentRoute: typeof StudioRoute
    }
    '/studio/courses/new': {
      id: '/studio/courses/new'
      path: '/new'
      fullPath: '/studio/courses/new'
      preLoaderRoute: typeof StudioCoursesNewRouteImport
      parentRoute: typeof StudioCoursesRoute
    }
    '/player/plenary/$learningObjectDraftId': {
      id: '/player/plenary/$learningObjectDraftId'
      path: '/plenary/$learningObjectDraftId'
      fullPath: '/player/plenary/$learningObjectDraftId'
      preLoaderRoute: typeof PlayerPlenaryLearningObjectDraftIdRouteImport
      parentRoute: typeof PlayerRoute
    }
    '/player/pbl/$pblDraftId': {
      id: '/player/pbl/$pblDraftId'
      path: '/pbl/$pblDraftId'
      fullPath: '/player/pbl/$pblDraftId'
      preLoaderRoute: typeof PlayerPblPblDraftIdRouteImport
      parentRoute: typeof PlayerRoute
    }
    '/player/learning-activity/$learningActivityDraftId': {
      id: '/player/learning-activity/$learningActivityDraftId'
      path: '/learning-activity/$learningActivityDraftId'
      fullPath: '/player/learning-activity/$learningActivityDraftId'
      preLoaderRoute: typeof PlayerLearningActivityLearningActivityDraftIdRouteImport
      parentRoute: typeof PlayerRoute
    }
    '/player/courses/$courseDraftIdentifier': {
      id: '/player/courses/$courseDraftIdentifier'
      path: '/courses/$courseDraftIdentifier'
      fullPath: '/player/courses/$courseDraftIdentifier'
      preLoaderRoute: typeof PlayerCoursesCourseDraftIdentifierRouteImport
      parentRoute: typeof PlayerRoute
    }
    '/player/assignment/$assignmentId': {
      id: '/player/assignment/$assignmentId'
      path: '/assignment/$assignmentId'
      fullPath: '/player/assignment/$assignmentId'
      preLoaderRoute: typeof PlayerAssignmentAssignmentIdRouteImport
      parentRoute: typeof PlayerRoute
    }
    '/player/courses/$courseDraftIdentifier/': {
      id: '/player/courses/$courseDraftIdentifier/'
      path: '/'
      fullPath: '/player/courses/$courseDraftIdentifier/'
      preLoaderRoute: typeof PlayerCoursesCourseDraftIdentifierIndexRouteImport
      parentRoute: typeof PlayerCoursesCourseDraftIdentifierRoute
    }
    '/studio/plenary/preview/$plenaryDraftId': {
      id: '/studio/plenary/preview/$plenaryDraftId'
      path: '/plenary/preview/$plenaryDraftId'
      fullPath: '/studio/plenary/preview/$plenaryDraftId'
      preLoaderRoute: typeof StudioPlenaryPreviewPlenaryDraftIdRouteImport
      parentRoute: typeof StudioRoute
    }
    '/studio/pbl/preview/$pblDraftId': {
      id: '/studio/pbl/preview/$pblDraftId'
      path: '/preview/$pblDraftId'
      fullPath: '/studio/pbl/preview/$pblDraftId'
      preLoaderRoute: typeof StudioPblPreviewPblDraftIdRouteImport
      parentRoute: typeof StudioPblRoute
    }
    '/studio/pbl/edit/$pblDraftId': {
      id: '/studio/pbl/edit/$pblDraftId'
      path: '/edit/$pblDraftId'
      fullPath: '/studio/pbl/edit/$pblDraftId'
      preLoaderRoute: typeof StudioPblEditPblDraftIdRouteImport
      parentRoute: typeof StudioPblRoute
    }
    '/studio/learning-activity/preview/$learningActivityDraftId': {
      id: '/studio/learning-activity/preview/$learningActivityDraftId'
      path: '/learning-activity/preview/$learningActivityDraftId'
      fullPath: '/studio/learning-activity/preview/$learningActivityDraftId'
      preLoaderRoute: typeof StudioLearningActivityPreviewLearningActivityDraftIdRouteImport
      parentRoute: typeof StudioRoute
    }
    '/studio/courses/preview/$courseDraftId': {
      id: '/studio/courses/preview/$courseDraftId'
      path: '/preview/$courseDraftId'
      fullPath: '/studio/courses/preview/$courseDraftId'
      preLoaderRoute: typeof StudioCoursesPreviewCourseDraftIdRouteImport
      parentRoute: typeof StudioCoursesRoute
    }
    '/studio/courses/edit/$courseDraftId': {
      id: '/studio/courses/edit/$courseDraftId'
      path: '/edit/$courseDraftId'
      fullPath: '/studio/courses/edit/$courseDraftId'
      preLoaderRoute: typeof StudioCoursesEditCourseDraftIdRouteImport
      parentRoute: typeof StudioCoursesRoute
    }
    '/studio/plenary/edit/$plenaryDraftId/': {
      id: '/studio/plenary/edit/$plenaryDraftId/'
      path: '/plenary/edit/$plenaryDraftId'
      fullPath: '/studio/plenary/edit/$plenaryDraftId'
      preLoaderRoute: typeof StudioPlenaryEditPlenaryDraftIdIndexRouteImport
      parentRoute: typeof StudioRoute
    }
    '/studio/learning-activity/edit/$learningActivityDraftId/': {
      id: '/studio/learning-activity/edit/$learningActivityDraftId/'
      path: '/learning-activity/edit/$learningActivityDraftId'
      fullPath: '/studio/learning-activity/edit/$learningActivityDraftId'
      preLoaderRoute: typeof StudioLearningActivityEditLearningActivityDraftIdIndexRouteImport
      parentRoute: typeof StudioRoute
    }
    '/studio/courses/preview/$courseDraftId/': {
      id: '/studio/courses/preview/$courseDraftId/'
      path: '/'
      fullPath: '/studio/courses/preview/$courseDraftId/'
      preLoaderRoute: typeof StudioCoursesPreviewCourseDraftIdIndexRouteImport
      parentRoute: typeof StudioCoursesPreviewCourseDraftIdRoute
    }
    '/studio/courses/edit/$courseDraftId/': {
      id: '/studio/courses/edit/$courseDraftId/'
      path: '/'
      fullPath: '/studio/courses/edit/$courseDraftId/'
      preLoaderRoute: typeof StudioCoursesEditCourseDraftIdIndexRouteImport
      parentRoute: typeof StudioCoursesEditCourseDraftIdRoute
    }
    '/player/courses/$courseDraftIdentifier/$categoryId/': {
      id: '/player/courses/$courseDraftIdentifier/$categoryId/'
      path: '/$categoryId'
      fullPath: '/player/courses/$courseDraftIdentifier/$categoryId'
      preLoaderRoute: typeof PlayerCoursesCourseDraftIdentifierCategoryIdIndexRouteImport
      parentRoute: typeof PlayerCoursesCourseDraftIdentifierRoute
    }
    '/studio/courses/edit/$courseDraftId/$categoryId': {
      id: '/studio/courses/edit/$courseDraftId/$categoryId'
      path: '/$categoryId'
      fullPath: '/studio/courses/edit/$courseDraftId/$categoryId'
      preLoaderRoute: typeof StudioCoursesEditCourseDraftIdCategoryIdRouteImport
      parentRoute: typeof StudioCoursesEditCourseDraftIdRoute
    }
    '/player/courses/$courseDraftIdentifier/$categoryId/$activityId': {
      id: '/player/courses/$courseDraftIdentifier/$categoryId/$activityId'
      path: '/$categoryId/$activityId'
      fullPath: '/player/courses/$courseDraftIdentifier/$categoryId/$activityId'
      preLoaderRoute: typeof PlayerCoursesCourseDraftIdentifierCategoryIdActivityIdRouteImport
      parentRoute: typeof PlayerCoursesCourseDraftIdentifierRoute
    }
    '/studio/plenary/edit/$plenaryDraftId/versions/': {
      id: '/studio/plenary/edit/$plenaryDraftId/versions/'
      path: '/plenary/edit/$plenaryDraftId/versions'
      fullPath: '/studio/plenary/edit/$plenaryDraftId/versions'
      preLoaderRoute: typeof StudioPlenaryEditPlenaryDraftIdVersionsIndexRouteImport
      parentRoute: typeof StudioRoute
    }
    '/studio/learning-activity/edit/$learningActivityDraftId/versions/': {
      id: '/studio/learning-activity/edit/$learningActivityDraftId/versions/'
      path: '/learning-activity/edit/$learningActivityDraftId/versions'
      fullPath: '/studio/learning-activity/edit/$learningActivityDraftId/versions'
      preLoaderRoute: typeof StudioLearningActivityEditLearningActivityDraftIdVersionsIndexRouteImport
      parentRoute: typeof StudioRoute
    }
    '/studio/courses/preview/$courseDraftId/$categoryId/': {
      id: '/studio/courses/preview/$courseDraftId/$categoryId/'
      path: '/$categoryId'
      fullPath: '/studio/courses/preview/$courseDraftId/$categoryId'
      preLoaderRoute: typeof StudioCoursesPreviewCourseDraftIdCategoryIdIndexRouteImport
      parentRoute: typeof StudioCoursesPreviewCourseDraftIdRoute
    }
    '/studio/plenary/edit/$plenaryDraftId/versions/$plenarySnapshotId': {
      id: '/studio/plenary/edit/$plenaryDraftId/versions/$plenarySnapshotId'
      path: '/plenary/edit/$plenaryDraftId/versions/$plenarySnapshotId'
      fullPath: '/studio/plenary/edit/$plenaryDraftId/versions/$plenarySnapshotId'
      preLoaderRoute: typeof StudioPlenaryEditPlenaryDraftIdVersionsPlenarySnapshotIdRouteImport
      parentRoute: typeof StudioRoute
    }
    '/studio/learning-activity/edit/$learningActivityDraftId/versions/$learningActivitySnapshotId': {
      id: '/studio/learning-activity/edit/$learningActivityDraftId/versions/$learningActivitySnapshotId'
      path: '/learning-activity/edit/$learningActivityDraftId/versions/$learningActivitySnapshotId'
      fullPath: '/studio/learning-activity/edit/$learningActivityDraftId/versions/$learningActivitySnapshotId'
      preLoaderRoute: typeof StudioLearningActivityEditLearningActivityDraftIdVersionsLearningActivitySnapshotIdRouteImport
      parentRoute: typeof StudioRoute
    }
    '/studio/courses/preview/$courseDraftId/$categoryId/$activityId': {
      id: '/studio/courses/preview/$courseDraftId/$categoryId/$activityId'
      path: '/$categoryId/$activityId'
      fullPath: '/studio/courses/preview/$courseDraftId/$categoryId/$activityId'
      preLoaderRoute: typeof StudioCoursesPreviewCourseDraftIdCategoryIdActivityIdRouteImport
      parentRoute: typeof StudioCoursesPreviewCourseDraftIdRoute
    }
  }
}

interface LobbyRouteChildren {
  LobbyPlenaryEndedRoute: typeof LobbyPlenaryEndedRoute
  LobbySignupRoute: typeof LobbySignupRoute
  LobbyIndexRoute: typeof LobbyIndexRoute
}

const LobbyRouteChildren: LobbyRouteChildren = {
  LobbyPlenaryEndedRoute: LobbyPlenaryEndedRoute,
  LobbySignupRoute: LobbySignupRoute,
  LobbyIndexRoute: LobbyIndexRoute,
}

const LobbyRouteWithChildren = LobbyRoute._addFileChildren(LobbyRouteChildren)

interface PlayerCoursesCourseDraftIdentifierRouteChildren {
  PlayerCoursesCourseDraftIdentifierIndexRoute: typeof PlayerCoursesCourseDraftIdentifierIndexRoute
  PlayerCoursesCourseDraftIdentifierCategoryIdActivityIdRoute: typeof PlayerCoursesCourseDraftIdentifierCategoryIdActivityIdRoute
  PlayerCoursesCourseDraftIdentifierCategoryIdIndexRoute: typeof PlayerCoursesCourseDraftIdentifierCategoryIdIndexRoute
}

const PlayerCoursesCourseDraftIdentifierRouteChildren: PlayerCoursesCourseDraftIdentifierRouteChildren =
  {
    PlayerCoursesCourseDraftIdentifierIndexRoute:
      PlayerCoursesCourseDraftIdentifierIndexRoute,
    PlayerCoursesCourseDraftIdentifierCategoryIdActivityIdRoute:
      PlayerCoursesCourseDraftIdentifierCategoryIdActivityIdRoute,
    PlayerCoursesCourseDraftIdentifierCategoryIdIndexRoute:
      PlayerCoursesCourseDraftIdentifierCategoryIdIndexRoute,
  }

const PlayerCoursesCourseDraftIdentifierRouteWithChildren =
  PlayerCoursesCourseDraftIdentifierRoute._addFileChildren(
    PlayerCoursesCourseDraftIdentifierRouteChildren,
  )

interface PlayerRouteChildren {
  PlayerLearningObjectDraftIdRoute: typeof PlayerLearningObjectDraftIdRoute
  PlayerAssignmentAssignmentIdRoute: typeof PlayerAssignmentAssignmentIdRoute
  PlayerCoursesCourseDraftIdentifierRoute: typeof PlayerCoursesCourseDraftIdentifierRouteWithChildren
  PlayerLearningActivityLearningActivityDraftIdRoute: typeof PlayerLearningActivityLearningActivityDraftIdRoute
  PlayerPblPblDraftIdRoute: typeof PlayerPblPblDraftIdRoute
  PlayerPlenaryLearningObjectDraftIdRoute: typeof PlayerPlenaryLearningObjectDraftIdRoute
}

const PlayerRouteChildren: PlayerRouteChildren = {
  PlayerLearningObjectDraftIdRoute: PlayerLearningObjectDraftIdRoute,
  PlayerAssignmentAssignmentIdRoute: PlayerAssignmentAssignmentIdRoute,
  PlayerCoursesCourseDraftIdentifierRoute:
    PlayerCoursesCourseDraftIdentifierRouteWithChildren,
  PlayerLearningActivityLearningActivityDraftIdRoute:
    PlayerLearningActivityLearningActivityDraftIdRoute,
  PlayerPblPblDraftIdRoute: PlayerPblPblDraftIdRoute,
  PlayerPlenaryLearningObjectDraftIdRoute:
    PlayerPlenaryLearningObjectDraftIdRoute,
}

const PlayerRouteWithChildren =
  PlayerRoute._addFileChildren(PlayerRouteChildren)

interface StudioCoursesEditCourseDraftIdRouteChildren {
  StudioCoursesEditCourseDraftIdCategoryIdRoute: typeof StudioCoursesEditCourseDraftIdCategoryIdRoute
  StudioCoursesEditCourseDraftIdIndexRoute: typeof StudioCoursesEditCourseDraftIdIndexRoute
}

const StudioCoursesEditCourseDraftIdRouteChildren: StudioCoursesEditCourseDraftIdRouteChildren =
  {
    StudioCoursesEditCourseDraftIdCategoryIdRoute:
      StudioCoursesEditCourseDraftIdCategoryIdRoute,
    StudioCoursesEditCourseDraftIdIndexRoute:
      StudioCoursesEditCourseDraftIdIndexRoute,
  }

const StudioCoursesEditCourseDraftIdRouteWithChildren =
  StudioCoursesEditCourseDraftIdRoute._addFileChildren(
    StudioCoursesEditCourseDraftIdRouteChildren,
  )

interface StudioCoursesPreviewCourseDraftIdRouteChildren {
  StudioCoursesPreviewCourseDraftIdIndexRoute: typeof StudioCoursesPreviewCourseDraftIdIndexRoute
  StudioCoursesPreviewCourseDraftIdCategoryIdActivityIdRoute: typeof StudioCoursesPreviewCourseDraftIdCategoryIdActivityIdRoute
  StudioCoursesPreviewCourseDraftIdCategoryIdIndexRoute: typeof StudioCoursesPreviewCourseDraftIdCategoryIdIndexRoute
}

const StudioCoursesPreviewCourseDraftIdRouteChildren: StudioCoursesPreviewCourseDraftIdRouteChildren =
  {
    StudioCoursesPreviewCourseDraftIdIndexRoute:
      StudioCoursesPreviewCourseDraftIdIndexRoute,
    StudioCoursesPreviewCourseDraftIdCategoryIdActivityIdRoute:
      StudioCoursesPreviewCourseDraftIdCategoryIdActivityIdRoute,
    StudioCoursesPreviewCourseDraftIdCategoryIdIndexRoute:
      StudioCoursesPreviewCourseDraftIdCategoryIdIndexRoute,
  }

const StudioCoursesPreviewCourseDraftIdRouteWithChildren =
  StudioCoursesPreviewCourseDraftIdRoute._addFileChildren(
    StudioCoursesPreviewCourseDraftIdRouteChildren,
  )

interface StudioCoursesRouteChildren {
  StudioCoursesNewRoute: typeof StudioCoursesNewRoute
  StudioCoursesEditCourseDraftIdRoute: typeof StudioCoursesEditCourseDraftIdRouteWithChildren
  StudioCoursesPreviewCourseDraftIdRoute: typeof StudioCoursesPreviewCourseDraftIdRouteWithChildren
}

const StudioCoursesRouteChildren: StudioCoursesRouteChildren = {
  StudioCoursesNewRoute: StudioCoursesNewRoute,
  StudioCoursesEditCourseDraftIdRoute:
    StudioCoursesEditCourseDraftIdRouteWithChildren,
  StudioCoursesPreviewCourseDraftIdRoute:
    StudioCoursesPreviewCourseDraftIdRouteWithChildren,
}

const StudioCoursesRouteWithChildren = StudioCoursesRoute._addFileChildren(
  StudioCoursesRouteChildren,
)

interface StudioPblRouteChildren {
  StudioPblNewRoute: typeof StudioPblNewRoute
  StudioPblEditPblDraftIdRoute: typeof StudioPblEditPblDraftIdRoute
  StudioPblPreviewPblDraftIdRoute: typeof StudioPblPreviewPblDraftIdRoute
}

const StudioPblRouteChildren: StudioPblRouteChildren = {
  StudioPblNewRoute: StudioPblNewRoute,
  StudioPblEditPblDraftIdRoute: StudioPblEditPblDraftIdRoute,
  StudioPblPreviewPblDraftIdRoute: StudioPblPreviewPblDraftIdRoute,
}

const StudioPblRouteWithChildren = StudioPblRoute._addFileChildren(
  StudioPblRouteChildren,
)

interface StudioRouteChildren {
  StudioBinRoute: typeof StudioBinRoute
  StudioCoursesRoute: typeof StudioCoursesRouteWithChildren
  StudioPblRoute: typeof StudioPblRouteWithChildren
  StudioTemplatesRoute: typeof StudioTemplatesRoute
  StudioIndexRoute: typeof StudioIndexRoute
  StudioLearningActivityNewRoute: typeof StudioLearningActivityNewRoute
  StudioPlenaryNewRoute: typeof StudioPlenaryNewRoute
  StudioLearningActivityPreviewLearningActivityDraftIdRoute: typeof StudioLearningActivityPreviewLearningActivityDraftIdRoute
  StudioPlenaryPreviewPlenaryDraftIdRoute: typeof StudioPlenaryPreviewPlenaryDraftIdRoute
  StudioLearningActivityEditLearningActivityDraftIdIndexRoute: typeof StudioLearningActivityEditLearningActivityDraftIdIndexRoute
  StudioPlenaryEditPlenaryDraftIdIndexRoute: typeof StudioPlenaryEditPlenaryDraftIdIndexRoute
  StudioLearningActivityEditLearningActivityDraftIdVersionsLearningActivitySnapshotIdRoute: typeof StudioLearningActivityEditLearningActivityDraftIdVersionsLearningActivitySnapshotIdRoute
  StudioPlenaryEditPlenaryDraftIdVersionsPlenarySnapshotIdRoute: typeof StudioPlenaryEditPlenaryDraftIdVersionsPlenarySnapshotIdRoute
  StudioLearningActivityEditLearningActivityDraftIdVersionsIndexRoute: typeof StudioLearningActivityEditLearningActivityDraftIdVersionsIndexRoute
  StudioPlenaryEditPlenaryDraftIdVersionsIndexRoute: typeof StudioPlenaryEditPlenaryDraftIdVersionsIndexRoute
}

const StudioRouteChildren: StudioRouteChildren = {
  StudioBinRoute: StudioBinRoute,
  StudioCoursesRoute: StudioCoursesRouteWithChildren,
  StudioPblRoute: StudioPblRouteWithChildren,
  StudioTemplatesRoute: StudioTemplatesRoute,
  StudioIndexRoute: StudioIndexRoute,
  StudioLearningActivityNewRoute: StudioLearningActivityNewRoute,
  StudioPlenaryNewRoute: StudioPlenaryNewRoute,
  StudioLearningActivityPreviewLearningActivityDraftIdRoute:
    StudioLearningActivityPreviewLearningActivityDraftIdRoute,
  StudioPlenaryPreviewPlenaryDraftIdRoute:
    StudioPlenaryPreviewPlenaryDraftIdRoute,
  StudioLearningActivityEditLearningActivityDraftIdIndexRoute:
    StudioLearningActivityEditLearningActivityDraftIdIndexRoute,
  StudioPlenaryEditPlenaryDraftIdIndexRoute:
    StudioPlenaryEditPlenaryDraftIdIndexRoute,
  StudioLearningActivityEditLearningActivityDraftIdVersionsLearningActivitySnapshotIdRoute:
    StudioLearningActivityEditLearningActivityDraftIdVersionsLearningActivitySnapshotIdRoute,
  StudioPlenaryEditPlenaryDraftIdVersionsPlenarySnapshotIdRoute:
    StudioPlenaryEditPlenaryDraftIdVersionsPlenarySnapshotIdRoute,
  StudioLearningActivityEditLearningActivityDraftIdVersionsIndexRoute:
    StudioLearningActivityEditLearningActivityDraftIdVersionsIndexRoute,
  StudioPlenaryEditPlenaryDraftIdVersionsIndexRoute:
    StudioPlenaryEditPlenaryDraftIdVersionsIndexRoute,
}

const StudioRouteWithChildren =
  StudioRoute._addFileChildren(StudioRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LobbyRoute: LobbyRouteWithChildren,
  LoginRoute: LoginRoute,
  LogoutRoute: LogoutRoute,
  PlayerRoute: PlayerRouteWithChildren,
  RedirectRoute: RedirectRoute,
  StudioRoute: StudioRouteWithChildren,
  TranslationsRoute: TranslationsRoute,
  UnauthorizedRoute: UnauthorizedRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
